import { ErrorHandler, Injectable } from '@angular/core';
import { ENV } from '../environments/environment';
let trackJs: any;

@Injectable()
export class TrackJsErrorHandler implements ErrorHandler {
  handleError(error: any) {
    if(ENV.mode !== "Production") {
      console.warn(error.message);
    }
    if (trackJs) {
      trackJs.track(error.originalError);
    }
  }
}



// WEBPACK FOOTER //
// ./src/error-handlers/trackjs-error-handler.ts